import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu';
import { useTranslation } from 'react-i18next';
import { useLanguageStore, LANGUAGES } from '@/stores/languageStore';
import { Icon } from '@/components/synapse/Icon';
import { cn } from '@/lib/utils';

export function LanguageToggle() {
  const { language, setLanguage } = useLanguageStore();
  const { t } = useTranslation();
  const current = LANGUAGES.find((l) => l.code === language) ?? LANGUAGES[0]!;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={t('common.changeLanguage')}
        title={t('common.language')}
        className="inline-flex h-8 items-center gap-1 rounded-md border border-line bg-paper px-2 text-[12px] font-medium text-ink-2 hover:bg-paper-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <span>{current.nativeLabel}</span>
        <Icon name="chevron_down" size={12} />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="top"
        align="start"
        sideOffset={6}
        className="z-50 min-w-[140px] rounded-md border border-line bg-paper p-1 shadow-lg"
      >
        {LANGUAGES.map((lng) => (
          <DropdownMenuItem
            key={lng.code}
            onSelect={() => setLanguage(lng.code)}
            className={cn(
              'flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-[12.5px] text-ink-2 outline-none hover:bg-paper-2 focus:bg-paper-2',
              lng.code === language && 'font-semibold text-ink',
            )}
          >
            <span className="flex-1">{lng.nativeLabel}</span>
            {lng.code === language && <Icon name="check" size={12} className="text-ink" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
